module.exports = __webpack_public_path__ + "img/menu.b4e2243c.jpeg";